module.exports = __webpack_public_path__ + "static/media/group.785511e8.png";